import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/privacidad")({
  head: () => pageHead("privacy", "es"),
  component: PrivacyPolicy,
});
